<template>
  <div class="button" :class="'button-' + type" :style="`width: ${width}; height: ${height};`" :disabled="disabled">
    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M3.38521 12.7416L2.39049 12.7327L2.40122 11.5596L1.21133 11.549L1.22031 10.5684L2.07385 9.74195L4.2388 11.9151L3.38521 12.7416ZM8.32495 4.27988C8.32445 4.33486 8.30524 4.38968 8.25851 4.4351L3.17446 9.35761C3.12756 9.40302 3.07158 9.42085 3.01581 9.42036C2.89495 9.41928 2.81204 9.33606 2.81313 9.21692C2.81363 9.16193 2.83291 9.1071 2.87968 9.06169L7.96368 4.13917C8.01058 4.09377 8.06652 4.07593 8.12232 4.07643C8.24314 4.0775 8.32604 4.16073 8.32495 4.27988ZM7.83907 2.51576L0.0348105 10.0721L-6.78233e-05 13.8847L3.86721 13.919L11.6715 6.36271L7.83907 2.51576ZM14.1804 3.45204C14.1832 3.14043 14.0559 2.83684 13.8441 2.61498L11.6791 0.451001C11.458 0.229064 11.1524 0.0980308 10.8362 0.0952202C10.5202 0.09241 10.2122 0.217988 9.99641 0.43604L8.4394 1.93451L12.2718 5.78145L13.8289 4.27381C14.0446 4.06492 14.1775 3.76364 14.1804 3.45204Z" fill="white"/>
    </svg>
    {{ title }}
  </div>
</template>

<script>
export default {
  name: 'app-button-comment-save',
  props: {
    title: String,
    type: String,
    width: {
      type: String,
      default: '160px'
    },
    height: {
      type: String,
      default: '40px'
    },
    hasPlayIcon: Boolean,
    disabled: Boolean
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '../../../assets/css/system/_vars';
@import '../../../assets/css/system/_mixins';

.button {
  display: flex;
  justify-content: center;
  align-items: center;
  color: $font_color_alt;
  border-radius: 3px;
  padding: 10px 15px;
  transition: .3s;
  cursor: pointer;
  user-select: none;
  font-family: $font_main;

  svg {
    margin-right: 8px;
  }
}

.button-main {
  background: $button_color;
  box-shadow: 0 2px 2px #C6523B;

  &[disabled] {
    background: $color_deactive;
    box-shadow: none;
    pointer-events: none;
  }

  &:hover {
    box-shadow: none;
  }

  &:active {
    box-shadow: inset 0px 4px 4px rgba(128, 37, 15, 0.54);
  }
}

.button-second {
  background: $button_color_second;
  box-shadow: 0px 2px 2px #4C095C;

  &[disabled] {
    background: $color_deactive;
    box-shadow: none;
    pointer-events: none;
  }

  &:hover {
    box-shadow: none;
  }

  &:active {
    box-shadow: inset 0 4px 4px rgba(44, 4, 48, 0.54);
  }
}

.button-third {
  background: $button_color_third;
  box-shadow: 0 2px 2px #13557C;

  &[disabled] {
    background: $color_deactive;
    box-shadow: none;
    pointer-events: none;
  }

  &:hover {
    box-shadow: none;
  }

  &:active {
    box-shadow: inset 0 4px 4px #0E476A;
  }
}

.button-fourth {
  background: $button_color_fourth;
  box-shadow: 0 2px 2px #557428;

  &[disabled] {
    background: $color_deactive;
    box-shadow: none;
    pointer-events: none;
  }

  &:hover {
    box-shadow: none;
  }

  &:active {
    box-shadow: inset 0 4px 4px #557428;
  }
}

.button-alt {
  background: $color_main;
  color: $font_color_second;
  border: 1px solid $font_color_second;
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.42);

  &[disabled] {
    color: $color_deactive;
    border: 1px solid $color_deactive;
    box-shadow: none;
    pointer-events: none;
  }

  &:hover {
    box-shadow: none;
  }

  &:active {
    box-shadow: inset 0px 4px 4px rgba(0, 0, 0, 0.45);
  }
}

.play-icon {
  margin-left: 8px;
}
</style>
